<template>
  <div class="main-content" v-loading="loading">
    <second-nav-bar></second-nav-bar>
    <div class="content">
      <div class="header">
        <span>运营 / 学年管理</span>
      </div>
      <div class="table-container scroll">
        <el-row>
          <el-col :span="24">
            <span
              style="color: var(--theme-color); font-size: 16px; font-weight: 500;"
              >{{ schoolYear }}</span
            >
            <span style="color: #444444; font-size: 16px; font-weight: 500;"
              >学期配置</span
            >
            <!-- TODO 正式环境暂时隐藏升学年功能 -->
            <el-button
              type="primary"
              size="medium"
              :disabled="!canEdit"
              style="float: right;"
              @click="upgradeSchoolYear"
              >学年升级</el-button
            >
          </el-col>
        </el-row>
        <el-row class="table">
          <el-col :span="24">
            <el-table :data="yearData">
              <el-table-column
                prop="left"
                label="学段"
                width="200"
              ></el-table-column>
              <el-table-column prop="middle" label="第一学期"></el-table-column>
              <el-table-column prop="right" label="第二学期"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>
    <loading-dialog
      ref="loadingDialog"
      title="学年升级进度"
      :dialogVisible.sync="dialogVisible"
      :percentFn="percentFn"
      :afterProgress="getSchoolYear"
    />
  </div>
</template>

<script>
import __ from '@/util/common-utils'
import SecondNavBar from '@/components/common/SecondNavBar'
import LoadingDialog from '@/components/common/loading-dialog'

export default {
  props: [],

  components: {
    'second-nav-bar': SecondNavBar,
    LoadingDialog
  },

  data() {
    return {
      yearData: [],
      schoolYear: '',
      canEdit: true,
      dialogVisible: false,
      loading: false
    }
  },

  watch: {},

  computed: {
    __() {
      return __
    }
  },

  mounted() {
    this.getSchoolYear()
    // this.initYear()
  },

  methods: {
    async getSchoolYear() {
      this.initYear()
      try {
        const [schoolYear, canEdit] = await this.__.defaultSchoolYear()
        this.schoolYear = schoolYear
        this.canEdit = canEdit
      } catch (error) {
        console.log(error)
        this.schoolYear = ''
        this.canEdit = false
      }
    },
    initYear() {
      this.$xhrGet(`/acc/schools/term`).then(rs => {
        this.yearData = rs.data
      })
    },
    async upgradeSchoolYear() {
      try {
        const { code } = await this.$xhrPost('/acc/schools/upgrade')
        if (code === 'SUCCESS') {
          this.loading = true
          setTimeout(() => {
            this.$refs.loadingDialog.progressOn(1000)
            this.dialogVisible = true
            this.loading = false
          }, 500)
        } else {
          switch (code) {
            case 'upgrade_completed':
              this.$message.success('学年已升级完成')
              break
            case 'upgrading':
              this.$message.warn('学年升级中')
              break
            default:
              break
          }
        }
      } catch (error) {
        console.log(error)
        this.$message.error('升级学年异常，请联系管理员')
      }
    },
    // 请求当前进度接口
    percentFn() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await this.$xhrGet('/acc/schools/upgrade/process')
          resolve(res)
        } catch (error) {
          reject(error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-content {
  width: 100%;
  height: 100%;
  position: relative;
  background: var(--theme-background);
}
.content {
  float: right;
  height: 100%;
  width: calc(100% - 200px);
}
.header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: #ffffff;
  border-bottom: tranparent;
  box-shadow: inset 1px 1px 4px 0px rgba(0, 0, 0, 0.12);
}
.header span {
  font-size: 14px;
  color: #757575;
  margin-left: 20px;
}
.table-container {
  width: calc(100% - 80px);
  max-height: calc(100% - 128px);
  overflow: auto;
  margin: 20px;
  padding: 20px;
  background: #fff;
  border-radius: 6px;
}
.table {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/operate/YearManage.vue